import {
  useAddAssetsToUxpTransferBatchMutation,
  useCreateUploadTransferJobMutation,
  useCreateUxpTransferBatchMutation,
  useStartUploadTransferJobMutation,
  useUpdateUxpTransferBatchMutation,
} from '../gql';

/**
 * UXP upload-pipeline mutations shared by `useCreateTransferAssets` and
 * `useDeferredTransferAssets` so the two flows can't drift.
 */
export function useUxpTransferMutations() {
  const [createTransferBatch] = useCreateUxpTransferBatchMutation();
  const [updateTransferBatch] = useUpdateUxpTransferBatchMutation();
  const [addAssetsToTransferBatch] = useAddAssetsToUxpTransferBatchMutation();

  const [createUXPTransferJob] = useCreateUploadTransferJobMutation({
    context: {
      resolveWithUXP: true,
    },
  });

  const [startTransferJob] = useStartUploadTransferJobMutation({
    context: {
      resolveWithUXP: true,
    },
  });

  return {
    addAssetsToTransferBatch,
    createTransferBatch,
    createUXPTransferJob,
    startTransferJob,
    updateTransferBatch,
  };
}

/**
 * `uploadUrls` from the API is `(string | null)[]` while the UXP host expects
 * `string[]`.
 */
export function filterUploadUrls(
  uploadUrls: readonly (string | null)[] | null | undefined
): string[] {
  return (uploadUrls ?? []).filter((url): url is string => url !== null);
}
